import * as Types from '../types/Hotel';

export const listHotelAction = (filters) => ({type: Types.HOTEL_LIST_ACTION, filters});
export const listHotelSuccess = (data) => ({type: Types.HOTEL_LIST_SUCCESS, data});

export const hotelClearStore = (params) => ({type: Types.HOTEL_FAIL, params});
